// lib/csv.ts
// No CSV export existed anywhere in the frontend before the Day Book report
// (ISS-09) — a small, reusable pair rather than a one-off inline in that
// screen, so the next report that needs export doesn't reinvent it.

/** Escapes a single value per RFC 4180: wraps in quotes only when the value
 * contains a comma, quote or newline, doubling any embedded quotes. */
function escapeCsvValue(value: unknown): string {
  const s = value === null || value === undefined ? '' : String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * @param rows plain objects — one row per record.
 * @param columns [key, header] pairs, in the order to print. The key indexes
 *   into each row; header is the printed column title.
 */
export function toCsv<T>(rows: T[], columns: Array<[keyof T, string]>): string {
  const header = columns.map(([, label]) => escapeCsvValue(label)).join(',');
  const body = rows.map((row) => columns.map(([key]) => escapeCsvValue(row[key])).join(','));
  return [header, ...body].join('\r\n');
}

/** Triggers a browser download of the given CSV text. */
export function downloadCsv(filename: string, csvText: string): void {
  // Leading BOM so Excel (still the overwhelmingly common opener in this
  // market) renders UTF-8 rupee symbols and non-ASCII names correctly
  // instead of guessing the wrong codepage.
  const blob = new Blob(['﻿' + csvText], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
